export default "__VITE_ASSET__BbchQmk___"